'use strict';

exports.__esModule = true;
exports.widget = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _widgetActions = require('../actions/widget-actions');

var _profileTransformers = require('../transformers/profile-transformers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var practices = void 0;

var widget = exports.widget = function widget(state, action) {
	switch (action.type) {
		case _widgetActions.LOAD_AVAILABILITIES + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				availabilities: action.response
			});
		case _widgetActions.LOAD_AVAILABILITIES + '_REQUESTED':
			return (0, _extends3.default)({}, state, {
				isLoading: true
			});
		case _widgetActions.LOAD_AVAILABILITIES + '_FAILED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				availabilities: []
			});
		case _widgetActions.LOAD_SPECIALIST_PROFILE + '_RECEIVED':
			practices = (0, _profileTransformers.transformPractices)(action.response && action.response.practices);
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialist: action.response,
				practices: [{ id: undefined, name: 'All practices' }].concat(practices)
			});
		case _widgetActions.LOAD_SPECIALIST_PROFILE + '_REQUESTED':
			return (0, _extends3.default)({}, state, {
				isLoading: true
			});
		case _widgetActions.LOAD_SPECIALIST_PROFILE + '_FAILED':
			return (0, _extends3.default)({}, state, {
				isLoading: false
			});
		case _widgetActions.PRACTICE_SELECTED:
			return (0, _assign2.default)({}, state, {
				selectedPractice: action.practice
			});
		case _widgetActions.UPDATE_START_DATE:
			return (0, _assign2.default)({}, state, {
				startDate: action.startDate
			});
		case _widgetActions.SET_NEAREST_AVAILABILITY:
			return (0, _assign2.default)({}, state, {
				nearestAvailability: action.date
			});
		case _widgetActions.SET_LATEST_AVAILABILITY_FOUND:
			return (0, _assign2.default)({}, state, {
				latestAvailabilityFound: action.date
			});
		default:
			return state || {
				startDate: (0, _moment2.default)()
			};
	}
};